export { default } from './FeaturedProduct'
